/** Admin "preview" hand-off: the editor writes the working copy here; the website reads it with ?preview=1. */
export const PREVIEW_STORAGE_KEY = 'mealnex-website-preview';

export function isPreviewRequest() {
  try { return new URLSearchParams(window.location.search).get('preview') === '1'; } catch { return false; }
}

export function readPreview(): unknown {
  try { const raw = localStorage.getItem(PREVIEW_STORAGE_KEY); return raw ? JSON.parse(raw) : null; } catch { return null; }
}
